// import React, { useState, useMemo } from "react";
// import { useSelector } from "react-redux";
// import useApi from "../../../CustomHooks/useApi";
// import { useDispatch } from "react-redux";
// import {
//     fetchWalletBalance,
//     fetchAepsBalance,
//     fetchSettlementBalance,
// } from "../../../Store/Slices/WalletSlice";

// const DthRecharge = () => {

//     const dispatch = useDispatch();

//     const token = useSelector((state) => state.auth.employeeDetails?.token);
//     const mid = useSelector((state) => state.auth.employeeDetails?.username);
//     const merchantAccountNo = useSelector(
//         (state) => state.auth.employeeDetails?.merchant_account_no
//     );
//     const [isSuccessTxn, setIsSuccessTxn] = useState(false);

//     // 🔹 useApi Hook
//     const { callApi: dthRechargeApi } = useApi(
//         "/recharge/dth/ezypay",
//         "POST"
//     );

//     const dthServices = [
//         {
//             service_id: "243",
//             service_name: "Airtel Digital TV",
//             service_code: "ATV",
//             params: {
//                 CustomerID: {
//                     param_name: "Account ID",
//                     full_regex: "^[0-9]{10}$",
//                 },
//             },
//         },
//         {
//             service_id: "241",
//             service_name: "Dish TV",
//             service_code: "DTV",
//             params: {
//                 CustomerID: {
//                     param_name: "Viewing Card Number",
//                     full_regex: "^[0-9]{11}$",
//                 },
//             },
//         },
//         {
//             service_id: "240",
//             service_name: "Sun Direct",
//             service_code: "STV",
//             params: {
//                 CustomerID: {
//                     param_name: "SMC",
//                     full_regex: "^[0-9]{11}$",
//                 },
//             },
//         },
//         {
//             service_id: "239",
//             service_name: "Tata Sky",
//             service_code: "TTV",
//             params: {
//                 CustomerID: {
//                     param_name: "Subscriber ID",
//                     full_regex: "^[0-9]{10}$",
//                 },
//             },
//         },
//         {
//             service_id: "242",
//             service_name: "Videocon d2h",
//             service_code: "VTV",
//             params: {
//                 CustomerID: {
//                     param_name: "Consumer ID",
//                     full_regex: "^[0-9]{4,14}$",
//                 },
//             },
//         },
//     ];

//     const [selectedServiceId, setSelectedServiceId] = useState("");
//     const [customerId, setCustomerId] = useState("");
//     const [amount, setAmount] = useState("");
//     const [mpin, setMpin] = useState("");
//     const [error, setError] = useState("");
//     const [loading, setLoading] = useState(false);

//     // Popup states (same style as your AEPS flow)
//     const [popupMessage, setPopupMessage] = useState("");
//     const [showPopup, setShowPopup] = useState(false);

//     const selectedService = useMemo(() => {
//         return dthServices.find(
//             (service) => service.service_id === selectedServiceId
//         );
//     }, [selectedServiceId]);

//     const showPopupMessage = (message) => {
//         setPopupMessage(message);
//         setShowPopup(true);
//     };

//     const handleCustomerIdChange = (e) => {
//         const value = e.target.value;
//         setCustomerId(value);

//         if (selectedService) {
//             const regex = new RegExp(
//                 selectedService.params.CustomerID.full_regex
//             );

//             if (!regex.test(value)) {
//                 setError(`Invalid ${selectedService.params.CustomerID.param_name}`);
//             } else {
//                 setError("");
//             }
//         }
//     };

//     const resetForm = () => {
//         setSelectedServiceId("");
//         setCustomerId("");
//         setAmount("");
//         setMpin("");
//         setError("");
//     };

//     const handleRecharge = async () => {
//         if (!selectedService || !amount || !mpin || !customerId || error) {
//             showPopupMessage("Please fill all fields correctly", "error");
//             return;
//         }

//         try {
//             setLoading(true);

//             const payload = {
//                 mid: mid,
//                 mpin: mpin,
//                 merchantAccountNo: merchantAccountNo,
//                 amount: Number(amount),
//                 operator: selectedService.service_code,
//                 customerId: customerId,
//             };

//             console.log("DTH Recharge Payload:", payload);

//             const response = await dthRechargeApi(payload);

//             console.log("DTH Recharge Response:", response);

//             // 🔹 Show customerSummary ONLY
//             // if (response?.customerSummary) {
//             //     const popupType =
//             //         response?.status === "SUCCESS"
//             //             ? "success"
//             //             : response?.status === "PENDING"
//             //                 ? "info"
//             //                 : "error";

//             //     showPopupMessage(response.customerSummary);
//             // } else {
//             //     showPopupMessage("Unexpected response from server", "error");
//             // }
//             const displayMessage =
//                 response?.customerSummary ||
//                 response?.message ||
//                 "Transaction Failed";

//             setIsSuccessTxn(response?.status === "SUCCESS");
//             showPopupMessage(displayMessage);


//         } catch (err) {
//             console.error(err);
//             showPopupMessage(
//                 err?.response?.data?.customerSummary ||
//                 err?.response?.data?.message ||
//                 "Something went wrong"
//             );
//         } finally {
//             setLoading(false);

//             dispatch(fetchWalletBalance());
//             dispatch(fetchAepsBalance());
//             dispatch(fetchSettlementBalance());
//         }
//     };


//     return (
//         <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-800 px-4 py-10">
//             <div className="w-full max-w-md bg-white/10 backdrop-blur-xl rounded-3xl shadow-2xl p-6 sm:p-8 border border-white/20">

//                 <h2 className="text-2xl font-semibold text-white text-center mb-6">
//                     DTH Recharge
//                 </h2>

//                 {/* Operator */}
//                 <div className="mb-4">
//                     <label className="text-white/80 text-sm block mb-2">
//                         Select Operator
//                     </label>
//                     <select
//                         value={selectedServiceId}
//                         onChange={(e) => {
//                             setSelectedServiceId(e.target.value);
//                             setCustomerId("");
//                             setError("");
//                         }}
//                         className="w-full rounded-xl bg-white/20 text-white px-4 py-3 focus:ring-2 focus:ring-cyan-400"
//                     >
//                         <option value="" className="text-black">
//                             Choose Operator
//                         </option>
//                         {dthServices.map((service) => (
//                             <option
//                                 key={service.service_id}
//                                 value={service.service_id}
//                                 className="text-black"
//                             >
//                                 {service.service_name}
//                             </option>
//                         ))}
//                     </select>
//                 </div>

//                 {/* Customer ID */}
//                 {selectedService && (
//                     <>
//                         <div className="mb-4">
//                             <label className="text-white/80 text-sm block mb-2">
//                                 {selectedService.params.CustomerID.param_name}
//                             </label>
//                             <input
//                                 type="tel"
//                                 value={customerId}
//                                 onChange={handleCustomerIdChange}
//                                 className={`w-full rounded-xl px-4 py-3 bg-white/20 text-white focus:ring-2 ${error ? "ring-2 ring-red-500" : "focus:ring-cyan-400"
//                                     }`}
//                             />
//                             {error && (
//                                 <p className="text-red-400 text-xs mt-1">{error}</p>
//                             )}
//                         </div>

//                         {/* Amount */}
//                         <div className="mb-4">
//                             <label className="text-white/80 text-sm block mb-2">
//                                 Amount
//                             </label>
//                             <input
//                                 type="number"
//                                 value={amount}
//                                 onChange={(e) => setAmount(e.target.value)}
//                                 className="w-full rounded-xl px-4 py-3 bg-white/20 text-white focus:ring-2 focus:ring-cyan-400"
//                             />
//                         </div>

//                         {/* MPIN */}
//                         <div className="mb-4">
//                             <label className="text-white/80 text-sm block mb-2">
//                                 MPIN
//                             </label>
//                             <input
//                                 type="password"
//                                 maxLength={6}
//                                 value={mpin}
//                                 onChange={(e) => setMpin(e.target.value)}
//                                 className="w-full rounded-xl px-4 py-3 bg-white/20 text-white focus:ring-2 focus:ring-cyan-400"
//                             />
//                         </div>

//                         {/* Button */}
//                         <button
//                             onClick={handleRecharge}
//                             disabled={loading}
//                             className="w-full bg-gradient-to-r from-cyan-400 to-blue-500 text-black font-semibold py-3 rounded-xl hover:scale-[1.02] transition-all disabled:opacity-50"
//                         >
//                             {loading ? "Processing..." : "Proceed Recharge"}
//                         </button>
//                     </>
//                 )}
//             </div>

//             {showPopup && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">

//                     <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 text-center animate-[fadeIn_.3s_ease]">

//                         <p className="text-gray-800 text-lg font-medium">
//                             {popupMessage}
//                         </p>

//                         <button
//                             onClick={() => {
//                                 setShowPopup(false);
//                                 if (isSuccessTxn) {
//                                     resetForm();
//                                 }
//                             }}
//                             className="mt-6 w-full bg-indigo-600 text-white py-2.5 rounded-xl hover:bg-indigo-700 transition"
//                         >
//                             OK
//                         </button>

//                     </div>
//                 </div>
//             )}

//         </div>
//     );
// };

// export default DthRecharge;

// import React, { useState, useMemo } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import useApi from "../../../CustomHooks/useApi";
// import {
//     fetchWalletBalance,
//     fetchAepsBalance,
//     fetchSettlementBalance,
// } from "../../../Store/Slices/WalletSlice";

// const DthRecharge = () => {
//     const dispatch = useDispatch();

//     const token = useSelector((state) => state.auth.employeeDetails?.token);
//     const mid = useSelector((state) => state.auth.employeeDetails?.username);
//     const merchantAccountNo = useSelector(
//         (state) => state.auth.employeeDetails?.merchant_account_no
//     );
//     const [isSuccessTxn, setIsSuccessTxn] = useState(false);

//     // 🔹 useApi Hook
//     const { callApi: dthRechargeApi } = useApi(
//         "/recharge/dth/ezypay",
//         "POST"
//     );

//     const dthServices = [
//         {
//             service_id: "243",
//             service_name: "Airtel Digital TV",
//             service_code: "ATV",
//             params: {
//                 CustomerID: {
//                     param_name: "Account ID",
//                     full_regex: "^[0-9]{10}$",
//                 },
//             },
//         },
//         {
//             service_id: "241",
//             service_name: "Dish TV",
//             service_code: "DTV",
//             params: {
//                 CustomerID: {
//                     param_name: "Viewing Card Number",
//                     full_regex: "^[0-9]{11}$",
//                 },
//             },
//         },
//         {
//             service_id: "240",
//             service_name: "Sun Direct",
//             service_code: "STV",
//             params: {
//                 CustomerID: {
//                     param_name: "SMC",
//                     full_regex: "^[0-9]{11}$",
//                 },
//             },
//         },
//         {
//             service_id: "239",
//             service_name: "Tata Sky",
//             service_code: "TTV",
//             params: {
//                 CustomerID: {
//                     param_name: "Subscriber ID",
//                     full_regex: "^[0-9]{10}$",
//                 },
//             },
//         },
//         {
//             service_id: "242",
//             service_name: "Videocon d2h",
//             service_code: "VTV",
//             params: {
//                 CustomerID: {
//                     param_name: "Consumer ID",
//                     full_regex: "^[0-9]{4,14}$",
//                 },
//             },
//         },
//     ];

//     const [selectedServiceId, setSelectedServiceId] = useState("");
//     const [customerId, setCustomerId] = useState("");
//     const [amount, setAmount] = useState("");
//     const [mpin, setMpin] = useState("");
//     const [error, setError] = useState("");
//     const [loading, setLoading] = useState(false);

//     // Popup states
//     const [popupMessage, setPopupMessage] = useState("");
//     const [showPopup, setShowPopup] = useState(false);

//     const selectedService = useMemo(() => {
//         return dthServices.find(
//             (service) => service.service_id === selectedServiceId
//         );
//     }, [selectedServiceId]);

//     const showPopupMessage = (message) => {
//         setPopupMessage(message);
//         setShowPopup(true);
//     };

//     const handleCustomerIdChange = (e) => {
//         const value = e.target.value;
//         setCustomerId(value);

//         if (selectedService) {
//             const regex = new RegExp(
//                 selectedService.params.CustomerID.full_regex
//             );

//             if (!regex.test(value)) {
//                 setError(`Invalid ${selectedService.params.CustomerID.param_name}`);
//             } else {
//                 setError("");
//             }
//         }
//     };

//     const resetForm = () => {
//         setSelectedServiceId("");
//         setCustomerId("");
//         setAmount("");
//         setMpin("");
//         setError("");
//     };

//     const handleRecharge = async () => {
//         if (!selectedService || !amount || !mpin || !customerId || error) {
//             showPopupMessage("Please fill all fields correctly", "error");
//             return;
//         }

//         try {
//             setLoading(true);

//             const payload = {
//                 mid: mid,
//                 mpin: mpin,
//                 merchantAccountNo: merchantAccountNo,
//                 amount: Number(amount),
//                 operator: selectedService.service_code,
//                 customerId: customerId,
//             };

//             console.log("DTH Recharge Payload:", payload);

//             const response = await dthRechargeApi(payload);

//             console.log("DTH Recharge Response:", response);

//             const displayMessage =
//                 response?.customerSummary ||
//                 response?.message ||
//                 "Transaction Failed";

//             setIsSuccessTxn(response?.status === "SUCCESS");
//             showPopupMessage(displayMessage);

//         } catch (err) {
//             console.error(err);
//             showPopupMessage(
//                 err?.response?.data?.customerSummary ||
//                 err?.response?.data?.message ||
//                 "Something went wrong"
//             );
//         } finally {
//             setLoading(false);

//             dispatch(fetchWalletBalance());
//             dispatch(fetchAepsBalance());
//             dispatch(fetchSettlementBalance());
//         }
//     };

//     return (
//         <div className="min-h-screen w-full bg-white flex flex-col items-center justify-start  pt-12 md:pt-0 px-6">
//             {/* Main Form Container - No card background, no borders, just clean layout */}
//             <div className="w-full pt-12">
                
//                 <h2 className="text-3xl md:text-4xl font-bold text-[#12345A] text-center mb-10 tracking-tight">
//                     DTH Recharge
//                 </h2>

//                 {/* Operator */}
//                 <div className="mb-6">
//                     <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
//                         Select Operator
//                     </label>
//                     <select
//                         value={selectedServiceId}
//                         onChange={(e) => {
//                             setSelectedServiceId(e.target.value);
//                             setCustomerId("");
//                             setError("");
//                         }}
//                         className="w-full rounded-lg bg-transparent border-b-2 border-gray-200 text-gray-900 px-2 py-3 text-lg focus:outline-none focus:border-[#12345A] transition-all cursor-pointer"
//                     >
//                         <option value="" className="text-gray-400">
//                             Choose Operator
//                         </option>
//                         {dthServices.map((service) => (
//                             <option
//                                 key={service.service_id}
//                                 value={service.service_id}
//                                 className="text-gray-900"
//                             >
//                                 {service.service_name}
//                             </option>
//                         ))}
//                     </select>
//                 </div>

//                 {/* Dynamic Fields */}
//                 {selectedService && (
//                     <div className="animate-[fadeIn_.3s_ease]">
//                         {/* Customer ID */}
//                         <div className="mb-6">
//                             <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
//                                 {selectedService.params.CustomerID.param_name}
//                             </label>
//                             <input
//                                 type="tel"
//                                 value={customerId}
//                                 onChange={handleCustomerIdChange}
//                                 placeholder={`Enter ${selectedService.params.CustomerID.param_name}`}
//                                 className={`w-full rounded-none bg-transparent border-b-2 text-gray-900 px-2 py-3 text-lg focus:outline-none transition-all ${
//                                     error 
//                                         ? "border-red-500" 
//                                         : "border-gray-200 focus:border-[#12345A]"
//                                 }`}
//                             />
//                             {error && (
//                                 <p className="text-red-500 text-xs mt-2 font-medium">{error}</p>
//                             )}
//                         </div>

//                         {/* Amount */}
//                         <div className="mb-6">
//                             <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
//                                 Amount (₹)
//                             </label>
//                             <input
//                                 type="number"
//                                 value={amount}
//                                 onChange={(e) => setAmount(e.target.value)}
//                                 placeholder="0.00"
//                                 className="w-full rounded-none bg-transparent border-b-2 border-gray-200 text-gray-900 px-2 py-3 text-lg focus:outline-none focus:border-[#12345A] transition-all"
//                             />
//                         </div>

//                         {/* MPIN */}
//                         <div className="mb-10">
//                             <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
//                                 MPIN
//                             </label>
//                             <input
//                                 type="password"
//                                 maxLength={6}
//                                 value={mpin}
//                                 onChange={(e) => setMpin(e.target.value)}
//                                 placeholder="••••••"
//                                 className="w-full rounded-none bg-transparent border-b-2 border-gray-200 text-[#12345A] px-2 py-3 text-2xl tracking-widest focus:outline-none focus:border-[#12345A] transition-all"
//                             />
//                         </div>

//                         {/* Submit Button */}
//                         <button
//                             onClick={handleRecharge}
//                             disabled={loading}
//                             className="w-full bg-[#12345A] text-white font-bold text-lg py-4 rounded-xl shadow-lg hover:bg-[#0d2644] hover:shadow-xl focus:ring-4 focus:ring-[#12345A]/20 transition-all disabled:opacity-60 disabled:cursor-not-allowed flex justify-center items-center"
//                         >
//                             {loading ? (
//                                 <span className="flex items-center gap-3">
//                                     <svg className="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                                         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                                         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                                     </svg>
//                                     Processing...
//                                 </span>
//                             ) : (
//                                 "Proceed Recharge"
//                             )}
//                         </button>
//                     </div>
//                 )}
//             </div>

//             {/* Popup Modal */}
//             {showPopup && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/90 backdrop-blur-sm px-4 transition-opacity">
//                     <div className="bg-white rounded-3xl shadow-[0_10px_40px_rgb(0,0,0,0.1)] border border-gray-100 w-full max-w-sm p-8 text-center animate-[fadeIn_.2s_ease-out]">
                        
//                         <div className={`mx-auto flex items-center justify-center h-16 w-16 rounded-full mb-6 ${isSuccessTxn ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`}>
//                             {isSuccessTxn ? (
//                                 <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"></path></svg>
//                             ) : (
//                                 <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12"></path></svg>
//                             )}
//                         </div>

//                         <p className="text-[#12345A] text-xl font-bold mb-8">
//                             {popupMessage}
//                         </p>

//                         <button
//                             onClick={() => {
//                                 setShowPopup(false);
//                                 if (isSuccessTxn) {
//                                     resetForm();
//                                 }
//                             }}
//                             className="w-full bg-[#12345A] text-white font-bold text-lg py-3.5 rounded-xl hover:bg-[#0d2644] transition-colors"
//                         >
//                             Done
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default DthRecharge;


import React, { useState, useMemo, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import {
    fetchWalletBalance,
    fetchAepsBalance,
    fetchSettlementBalance,
} from "../../../Store/Slices/WalletSlice";

// ==========================================
// 1. IMPORT YOUR LOGOS HERE
// Replace these paths with your actual folder paths
// ==========================================
import airtelLogo from "../../../Assets/Dthicons/airtel.png"; 
import dishTvLogo from "../../../Assets/Dthicons/dishtv.png";
import sunDirectLogo from "../../../Assets/Dthicons/suntv.png";
import tataSkyLogo from "../../../Assets/Dthicons/Tatasky.png";
import videoconLogo from "../../../Assets/Dthicons/d2h.png";

const DthRecharge = () => {
    const dispatch = useDispatch();

    const token = useSelector((state) => state.auth.employeeDetails?.token);
    const mid = useSelector((state) => state.auth.employeeDetails?.username);
    const merchantAccountNo = useSelector(
        (state) => state.auth.employeeDetails?.merchant_account_no
    );
    const [isSuccessTxn, setIsSuccessTxn] = useState(false);

    // 🔹 useApi Hook
    const { callApi: dthRechargeApi } = useApi(
        "/recharge/dth/ezypay",
        "POST"
    );

    // ==========================================
    // 2. MAP LOGOS TO SERVICES
    // ==========================================
    const dthServices = [
        {
            service_id: "243",
            service_name: "Airtel Digital TV",
            service_code: "ATV",
            logo: airtelLogo,
            params: {
                CustomerID: {
                    param_name: "Account ID",
                    full_regex: "^[0-9]{10}$",
                },
            },
        },
        {
            service_id: "241",
            service_name: "Dish TV",
            service_code: "DTV",
            logo: dishTvLogo,
            params: {
                CustomerID: {
                    param_name: "Viewing Card Number",
                    full_regex: "^[0-9]{11}$",
                },
            },
        },
        {
            service_id: "240",
            service_name: "Sun Direct",
            service_code: "STV",
            logo: sunDirectLogo,
            params: {
                CustomerID: {
                    param_name: "SMC",
                    full_regex: "^[0-9]{11}$",
                },
            },
        },
        {
            service_id: "239",
            service_name: "Tata Sky",
            service_code: "TTV",
            logo: tataSkyLogo,
            params: {
                CustomerID: {
                    param_name: "Subscriber ID",
                    full_regex: "^[0-9]{10}$",
                },
            },
        },
        {
            service_id: "242",
            service_name: "Videocon d2h",
            service_code: "VTV",
            logo: videoconLogo,
            params: {
                CustomerID: {
                    param_name: "Consumer ID",
                    full_regex: "^[0-9]{4,14}$",
                },
            },
        },
    ];

    const [selectedServiceId, setSelectedServiceId] = useState("");
    const [customerId, setCustomerId] = useState("");
    const [amount, setAmount] = useState("");
    const [mpin, setMpin] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    // Custom Dropdown States
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Popup states
    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const selectedService = useMemo(() => {
        return dthServices.find(
            (service) => service.service_id === selectedServiceId
        );
    }, [selectedServiceId]);

    // Handle closing dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const showPopupMessage = (message) => {
        setPopupMessage(message);
        setShowPopup(true);
    };

    const handleCustomerIdChange = (e) => {
        const value = e.target.value;
        setCustomerId(value);

        if (selectedService) {
            const regex = new RegExp(
                selectedService.params.CustomerID.full_regex
            );

            if (!regex.test(value)) {
                setError(`Invalid ${selectedService.params.CustomerID.param_name}`);
            } else {
                setError("");
            }
        }
    };

    const resetForm = () => {
        setSelectedServiceId("");
        setCustomerId("");
        setAmount("");
        setMpin("");
        setError("");
    };

    const handleRecharge = async () => {
        if (!selectedService || !amount || !mpin || !customerId || error) {
            showPopupMessage("Please fill all fields correctly", "error");
            return;
        }

        try {
            setLoading(true);

            const payload = {
                mid: mid,
                mpin: mpin,
                merchantAccountNo: merchantAccountNo,
                amount: Number(amount),
                operator: selectedService.service_code,
                customerId: customerId,
            };

            const response = await dthRechargeApi(payload);

            const displayMessage =
                response?.customerSummary ||
                response?.message ||
                "Transaction Failed";

            setIsSuccessTxn(response?.status === "SUCCESS");
            showPopupMessage(displayMessage);

        } catch (err) {
            console.error(err);
            showPopupMessage(
                err?.response?.data?.customerSummary ||
                err?.response?.data?.message ||
                "Something went wrong"
            );
        } finally {
            setLoading(false);

            dispatch(fetchWalletBalance());
            dispatch(fetchAepsBalance());
            dispatch(fetchSettlementBalance());
        }
    };

    return (
        <div className="min-h-screen w-full bg-white flex flex-col items-center justify-start pt-12 md:pt-0 px-6">
            <div className="w-full pt-12">
                
                <h2 className="text-3xl md:text-4xl font-bold text-[#12345A] text-center mb-10 tracking-tight">
                    DTH Recharge
                </h2>

                {/* ==========================================
                    3. CUSTOM LOGO DROPDOWN COMPONENT
                   ========================================== */}
                <div className="mb-6 relative" ref={dropdownRef}>
                    <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                        Select Operator
                    </label>
                    
                    {/* Selected Item View */}
                    <div 
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        className={`w-full flex items-center justify-between rounded-none bg-transparent border-b-2 px-2 py-3 text-lg cursor-pointer transition-all ${
                            isDropdownOpen ? "border-[#12345A]" : "border-gray-200 hover:border-gray-300"
                        }`}
                    >
                        {selectedService ? (
                            <div className="flex items-center gap-3">
                                <img 
                                    src={selectedService.logo} 
                                    alt={selectedService.service_name} 
                                    className="w-8 h-8 object-contain rounded-full shadow-sm border border-gray-100"
                                />
                                <span className="text-gray-900 px-3 py-4 text-xl md:text-2xl">{selectedService.service_name}</span>
                            </div>
                        ) : (
                            <span className="text-gray-400">Choose Operator</span>
                        )}
                        
                        {/* Dropdown Arrow */}
                        <svg 
                            className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : ""}`} 
                            fill="none" stroke="currentColor" viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                    </div>

                    {/* Dropdown Menu List */}
                    {isDropdownOpen && (
                        <div className="absolute z-20 w-full mt-2 bg-white border border-gray-100 rounded-2xl shadow-[0_10px_40px_rgb(0,0,0,0.08)] overflow-hidden animate-[fadeIn_.2s_ease-out]">
                            {dthServices.map((service) => (
                                <div
                                    key={service.service_id}
                                    onClick={() => {
                                        setSelectedServiceId(service.service_id);
                                        setCustomerId("");
                                        setError("");
                                        setIsDropdownOpen(false);
                                    }}
                                    className={`flex items-center gap-4 px-3 py-4 text-xl  cursor-pointer transition-colors ${
                                        selectedServiceId === service.service_id 
                                            ? "bg-indigo-50 border-l-4 border-[#12345A]" 
                                            : "hover:bg-gray-50 border-l-4 border-transparent"
                                    }`}
                                >
                                    <img 
                                        src={service.logo} 
                                        alt={service.service_name} 
                                        className="w-10 h-10 object-contain rounded-full shadow-sm border border-gray-100 bg-white"
                                    />
                                    <span className="text-gray-900 font-medium">{service.service_name}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Dynamic Fields */}
                {selectedService && (
                    <div className="animate-[fadeIn_.3s_ease]">
                        {/* Customer ID */}
                        <div className="mb-6">
                            <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                                {selectedService.params.CustomerID.param_name}
                            </label>
                            <input
                                type="tel"
                                value={customerId}
                                onChange={handleCustomerIdChange}
                                placeholder={`Enter ${selectedService.params.CustomerID.param_name}`}
                                className={`w-full rounded-none bg-transparent border-b-2 text-gray-900 px-3 py-4 text-xl md:text-2xl focus:outline-none transition-all ${
                                    error 
                                        ? "border-red-500" 
                                        : "border-gray-200 focus:border-[#12345A]"
                                }`}
                            />
                            {error && (
                                <p className="text-red-500 text-xs mt-2 font-medium">{error}</p>
                            )}
                        </div>

                        {/* Amount */}
                        <div className="mb-6">
                            <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                                Amount (₹)
                            </label>
                            <input
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="0.00"
                                className="w-full rounded-none bg-transparent border-b-2 border-gray-200 text-gray-900 px-3 py-4 text-xl md:text-2xl focus:outline-none focus:border-[#12345A] transition-all"
                            />
                        </div>

                        {/* MPIN */}
                        <div className="mb-10">
                            <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                                MPIN
                            </label>
                            <input
                                type="password"
                                maxLength={6}
                                value={mpin}
                                onChange={(e) => setMpin(e.target.value)}
                                placeholder="••••••"
                                className="w-full rounded-none bg-transparent border-b-2 border-gray-200 text-[#12345A] px-3 py-4 text-xl md:text-2xl tracking-widest focus:outline-none focus:border-[#12345A] transition-all"
                            />
                        </div>

                        {/* Submit Button */}
                        <button
                            onClick={handleRecharge}
                            disabled={loading}
                            className="w-full bg-[#12345A] text-white font-bold text-lg py-4 rounded-xl shadow-lg hover:bg-[#0d2644] hover:shadow-xl focus:ring-4 focus:ring-[#12345A]/20 transition-all disabled:opacity-60 disabled:cursor-not-allowed flex justify-center items-center"
                        >
                            {loading ? (
                                <span className="flex items-center gap-3">
                                    <svg className="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Processing...
                                </span>
                            ) : (
                                "Proceed Recharge"
                            )}
                        </button>
                    </div>
                )}
            </div>

            {/* Popup Modal */}
            {showPopup && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/90 backdrop-blur-sm px-4 transition-opacity">
                    <div className="bg-white rounded-3xl shadow-[0_10px_40px_rgb(0,0,0,0.1)] border border-gray-100 w-full max-w-sm p-8 text-center animate-[fadeIn_.2s_ease-out]">
                        
                        <div className={`mx-auto flex items-center justify-center h-16 w-16 rounded-full mb-6 ${isSuccessTxn ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`}>
                            {isSuccessTxn ? (
                                <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"></path></svg>
                            ) : (
                                <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12"></path></svg>
                            )}
                        </div>

                        <p className="text-[#12345A] text-xl font-bold mb-8">
                            {popupMessage}
                        </p>

                        <button
                            onClick={() => {
                                setShowPopup(false);
                                if (isSuccessTxn) {
                                    resetForm();
                                }
                            }}
                            className="w-full bg-[#12345A] text-white font-bold text-lg py-3.5 rounded-xl hover:bg-[#0d2644] transition-colors"
                        >
                            Done
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DthRecharge;